export interface BreakpointConfig {
  scene: Phaser.Scene;
  desktopView: Phaser.GameObjects.Container;
  tabletView?: Phaser.GameObjects.Container;
  mobileView?: Phaser.GameObjects.Container;
}

export interface ResponsiveComponentMap {
  [key: string]: ResponsiveComponent;
}

export interface ResponsiveComponent {
  desktop: Phaser.GameObjects.GameObject;
  tablet?: Phaser.GameObjects.GameObject;
  mobile?: Phaser.GameObjects.GameObject;
}

export interface ScaleDownConfig {
  scaleModifier?: number;
  breakpoints?: {
    width?: number;
    height?: number;
  };
  accountForWidth?: boolean;
  accountForHeight?: boolean;
}

export type ResponsivenessView = 'desktop' | 'tablet' | 'mobile';

export const BREAKPOINT_TABLET = 780;
export const BREAKPOINT_MOBILE = 667;
export const DEFAULT_SCALE_DOWN_CONFIG = {
  scaleModifier: 1,
  breakpoints: {
    width: 1300,
  },
  accountForHeight: false,
};
